import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import { request as baseRequest } from "@xo-union/fetch-request-builder";
import configure from "./configure/index.js";

var _request = /*#__PURE__*/new _WeakMap();

export default class GeoClient {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classPrivateFieldInitSpec(this, _request, {
      writable: true,
      value: void 0
    });

    const {
      host,
      apiKey
    } = configure(config);
    const {
      request = baseRequest
    } = config;

    _classPrivateFieldSet(this, _request, request.host(host).query({
      apiKey
    }));
  }

  locationsByCity(city, params) {
    return _classPrivateFieldGet(this, _request).get(`/geo/locations/city/${city}`).query({
      limit: 100,
      ...params
    }).readJsonBody();
  }

  locationsByClientIP(params) {
    return _classPrivateFieldGet(this, _request).get('/geo/locations/ip').query(params).readJsonBody();
  }

  geoByClientIP(params) {
    return _classPrivateFieldGet(this, _request).get('/geo/ip').query(params).readJsonBody();
  }

}